import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import CustomSwitch from "components/Input/CustomSwitch.js";
import TextInput from "components/Input/TextInput.js";
import UserService from "services/UserService";
import { makeStyles } from "@mui/styles";
import { comptepage } from "variables/tertiaryBill";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { getSite, postTertiaryBill } from "services/ConfigServices";
import { NotificationManager } from 'react-notifications';
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import styled from "styled-components";
import CustomConfirmationButton from "components/CustomButtons/CustomConfirmationButton.js";
import GetAppIcon from '@mui/icons-material/GetApp';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
  testButton: {
    color: "#FFFFFF",
    backgroundColor: "#3E8FC6",
    fontWeight: "bold",
    display: "block",
    marginTop: "14px",
    marginRight: "auto",
    marginLeft: "1ch",
    width: "35ch",
    "&:hover": {
      backgroundColor: "#3E8FC6",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  testButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "14px",
    marginRight: "auto",
    marginLeft: "1ch",
    width: "35ch",
  },
}));

const ResultsDiv = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

export default function API(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const [apiinterface, setApinterface] = useState(false);
  const [sirenstructure, setSirenstructure] = useState("");
  const [userkey, setUserkey] = useState("");
  const [testButtonDisabled, setTestButtonDisabled] = useState(true);
  const [testtext, setTesttext] = useState("");
  const [testtextcolor, setTesttextcolor] = useState("");
  const [testresults, setTestresults] = useState([]);
  const [resultsToDownload, setResultsToDownload] = useState(false);
  const [apivalidated, setApivalidated] = useState(false);
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const [getAllButtonDisabled, setGetAllButtonDisabled] = useState(true);
  const [getAllProgression, setGetAllProgression] = useState({});
  const [getAlltext, setGetAlltext] = useState("");
  const [getAlltextcolor, setGetAlltextcolor] = useState("");

  const handleApiinterfaceChange = () => {
    setApinterface(!apiinterface);
  };
  const handleSirenstructureChange = (event) => {
    setSirenstructure(event.target.value);
  };
  const handleUserkeyChange = (event) => {
    setUserkey(event.target.value);
  };

  useEffect(() => {
    setResultsToDownload(false);
    setApivalidated(false);
    setTesttextcolor("");
    setTesttext("");
    if (!sirenstructure || !userkey)
      setTestButtonDisabled(true);
    else
      setTestButtonDisabled(false);
  }, [sirenstructure, userkey]);

  useEffect(() => {
    setGetAllButtonDisabled(!apivalidated);
    if (getAllProgression?.status && getAllProgression.status === 'progress')
      setGetAllButtonDisabled(true);
  }, [apivalidated, getAllProgression?.status]);

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "tertiarybill"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setApinterface(res.data.detail.tertiarybill?.apiinterface);
        setSirenstructure(res.data.detail.tertiarybill?.sirenstructure);
        setUserkey(res.data.detail.tertiarybill?.userkey);
        setApivalidated(res.data.detail.tertiarybill?.apivalidated);
        setGetAllProgression(res.data.detail.tertiarybill?.getallprogression);
        if (res.data.detail.tertiarybill?.getallprogression) {
          let tmpgetallprogression = res.data.detail.tertiarybill.getallprogression;
          let text = "";
          if (tmpgetallprogression.status) {
            if (tmpgetallprogression.status === 'progress')
              text += comptepage.getalltextprogress;
            else if (tmpgetallprogression.status === 'done')
              text += comptepage.getalltextdone;
          }
          if ("total" in tmpgetallprogression) {
            text += " " + tmpgetallprogression.total + " " + comptepage.getalltotalefa;
          }
          if ("success" in tmpgetallprogression) {
            text += " " + tmpgetallprogression.success + " " + comptepage.getallsuccessefa;
          }
          if ("error" in tmpgetallprogression) {
            text += " " + tmpgetallprogression.error + " " + comptepage.getallerrorefa;
          }
          if ("partial" in tmpgetallprogression) {
            text += " " + tmpgetallprogression.partial + " " + comptepage.getallpartialefa;
          }
          setGetAlltext(text);
          setGetAlltextcolor("#FF763A");
        }
      });
  }, []);


  const handleTestAPI = async (event) => {
    setTestButtonDisabled(true);
    setTesttextcolor("##FF763A");
    setResultsToDownload(false);
    setTesttext(comptepage.waitfortestresult);
    axios
      .post(
        postTertiaryBill("testapi"),
        {
          apiinterface,
          sirenstructure,
          userkey,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          if (res.data.status === 'success') {
            setTesttextcolor("#91C73C");
            setTesttext(comptepage.resultsuccess + " " + res.data.consommationsresponse.nbConsommations + " " + comptepage.resultconsumptions);
            let testresults_tmp = res.data.consommationsresponse.resultat;
            let exportarray = [];
            exportarray = testresults_tmp.map((item) => {
              let efatoexport = {};
              efatoexport[comptepage.adresseEfa] = (item.adresseEfa?.numeroNomVoie + ", " || "") + (item.adresseEfa?.codePostal + " " || "") + (item.adresseEfa?.commune + " " || "");
              efatoexport[comptepage.complementNomEfa] = (item.complementNomEfa || "");
              efatoexport[comptepage.denominationOccupantEfa] = (item.denominationOccupantEfa || "");
              efatoexport[comptepage.idOccupantEfa] = (item.idOccupantEfa || "");
              efatoexport[comptepage.refOperatEfa] = (item.refOperatEfa || "");
              efatoexport[comptepage.typeOccupantEfa] = (item.typeOccupantEfa || "");
              return efatoexport;
            });
            setTestresults(exportarray);
            setResultsToDownload(true);
            setApivalidated(true);
          }
          else {
            setTesttextcolor("#C53F3F");
            setTesttext(comptepage.resultfailed);
          }
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const handleTestGetAll = async (event) => {
    setGetAllButtonDisabled(true);
    let progression = {};
    progression.status = 'progress';
    setGetAllProgression(progression);
    setGetAlltextcolor("#FF763A");
    setGetAlltext(comptepage.waitfortestresult);
    axios
      .post(
        postTertiaryBill("getall"),
        {
          apiinterface,
          sirenstructure,
          userkey,
          account: chartIdGroup[0]
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          if (res.data.status === 'success') {
            setGetAlltextcolor("#91C73C");
            setGetAlltext(comptepage.resultsuccess + " " + res.data.consommationsresponse.nbConsommations + " " + comptepage.resultconsumptions + " " + comptepage.getalltextprogress);
          }
          else {
            setGetAlltextcolor("#C53F3F");
            setGetAlltext(comptepage.resultfailed);
          }
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const handleEdit = async (event) => {
    axios
      .put(
        getSite(chartIdGroup, "tertiarybill"),
        {
          apiinterface,
          sirenstructure,
          userkey,
          apivalidated,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const classes = useStyles();

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <CustomSwitch
              disabled={!realestateupdate}
              inputTitle={comptepage.apiinterface}
              checkedState={apiinterface}
              handleSwitchChange={handleApiinterfaceChange}
            />
          </div>
          {
            apiinterface ?
              <>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <div>
                      <TextInput
                        inputTitle={comptepage.sirenstructure}
                        textInput={sirenstructure}
                        handleTextInputChange={handleSirenstructureChange}
                        disabled={!realestateupdate}
                        maxLength={9}
                      />
                    </div>
                    <div>
                      <TextInput
                        inputTitle={comptepage.userkey}
                        textInput={userkey}
                        handleTextInputChange={handleUserkeyChange}
                        disabled={!realestateupdate}
                      />
                    </div>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <Button
                      disabled={testButtonDisabled}
                      className={
                        testButtonDisabled
                          ? classes.testButtonDisabled
                          : classes.testButton
                      }
                      onClick={() => {
                        handleTestAPI();
                      }}
                    >
                      {comptepage.testapibutton}
                    </Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <ResultsDiv>
                      {
                        resultsToDownload ?
                          <ExportTableToCSV dataarray={testresults} />
                          : <></>
                      }
                      <div style={{ color: "" + testtextcolor, marginTop: "8px", marginLeft: "10px", fontWeight: "bold" }}>{testtext}
                      </div>

                    </ResultsDiv>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomConfirmationButton
                      disabled={getAllButtonDisabled}
                      padding={"0 10px"}
                      width={"350px"}
                      height={"41px"}
                      title={comptepage.getalldatabutton}
                      dialogtitle={comptepage.getalldatabutton}
                      subTitle={comptepage.getalldataconfirmation}
                      confirmation={comptepage.getallyes}
                      // icon={<GetAppIcon fontSize="large" />}
                      tooltip={comptepage.getalldatabutton}
                      color="warning"
                      handleConfirmation={handleTestGetAll}
                    />
                  </GridItem>
                  <ResultsDiv>
                    <div style={{ color: "" + getAlltextcolor, marginTop: "8px", marginLeft: "20px", fontWeight: "bold" }}>{getAlltext}
                    </div>
                  </ResultsDiv>
                </GridContainer>

              </>
              :
              <>
              </>
          }

        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "2.5rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ?
              <Button
                style={{
                  color: "#FFFFFF",
                  backgroundColor: "#91C73C",
                  fontWeight: "normal",
                  fontWeight: "bold",
                  height: "40px",
                  fontSize: "0.75rem",
                  padding: "5px 15px",
                  marginRight: "5px",
                  marginBottom: "0px",
                  marginTop: "0px",
                  fontFamily: '"Source Sans Pro",sans-serif',
                }}
                onClick={() => {
                  handleEdit();
                }}
              >
                Enregistrer
              </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>
    </div>
  );
}
